import React, { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { SelectCard } from '@/design-system'
import { getWizardScenes } from '../../catalog'
import { getGallerySlotCount } from '../../galleryMeshCatalog'
import { StepHint, StepLead } from '../StepCopy'

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 16,
  '@media (min-width: 640px)': {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  '@media (min-width: 900px)': {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
})

export interface ScenePickerProps {
  value?: string | number
  onChange: (id: string | number) => void
}

export function ScenePicker({ value, onChange }: ScenePickerProps) {
  const scenes = useMemo(() => getWizardScenes(), [])
  const selected = scenes.find((s) => s.id === value)

  return (
    <Box>
      <StepLead>
        Choose the gallery room your photos will live in. You can fine-tune later in the editor.
      </StepLead>

      {scenes.length === 0 ? (
        <Box
          sx={{
            height: 180,
            borderRadius: 20,
            border: '1.5px dashed var(--ds-border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontSize: 13, color: 'var(--ds-ink-subtle)' }}>
            No scenes available
          </Typography>
        </Box>
      ) : (
        <Grid>
          {scenes.map((s) => (
            <SelectCard
              key={String(s.id)}
              title={s.name}
              subtitle={`${getGallerySlotCount(s.id)} prints`}
              imageUrl={s.thumbUrl}
              aspectRatio='16 / 10'
              selected={value === s.id}
              onClick={() => onChange(s.id)}
            />
          ))}
        </Grid>
      )}

      {selected && <StepHint>{selected.name} · {getGallerySlotCount(selected.id)} print slots — continue to frames.</StepHint>}
    </Box>
  )
}
